var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"execution"},[_c('basic-container',[_c('avue-crud',{attrs:{"data":_vm.data,"option":_vm.option}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }